export const PROFILE = 'PROFILE'
export const LOGOUT = 'LOGOUT'
export const COMPANY_CHANGE = 'COMPANY_CHANGE'
export const MENU = 'MENU'
export const COMPANIES = 'COMPANIES'
